export interface UserData {
  userId: string;
  email: string;
  profilePhotoUrl?: string;
  username?: string;
  verified?: boolean;
  phoneNumber?: string;
  stripeCustomerId?: string;
  role?: string;
  profileComplete?: boolean;
  admin?: boolean;
  location?: Location;
}

export interface Location {
  lat?: number;
  lng?: number;
  displayName?: string;
  street?: string;
  state?: string;
  country?: string;
  postcode?: string;
}

// src/data/data.ts

// src/data/data.ts

export const businessTypes = [
  { label: "visitor", value: "Guest" },
  { label: "contractor", value: "Business Owner" },
  { label: "employer", value: "Crew hiring" },
  { label: "jobSeeker", value: "Crew seeking position" },
  { label: "marina", value: "Marina" },
];

// src/data/data.ts

export const RoleDisplayingStripe = (role: string): string => {
  switch (role.toLowerCase()) {
    case "visitor":
      return "Guest";
    case "contractor":
      return "Business Owner";
    case "employer":
      return "Crew Hiring";
    case "jobseeker":
      return "Crew Seeking";
    case "marina":
      return "Marina";
    case "standard":
      return "Standard";
    case "premium":
      return "Premium";
    default:
      return role;
  }
};
